enum DriveBookingStatus {
  RESERVED = 10,
  STARTED = 20,
  FINISHED = 30,
  NO_SHOW = 90,
  CANCELED = 99
}

export default DriveBookingStatus;
